// 菜单项
import { getPath } from '@/scripts/utils';
import { MoreTwo, Order, Sailboat, TransactionOrder } from '@icon-park/react';
import {
    // PATH_MAKE_ORDER,
    PATH_MAKE_ORDER_LIST,
    PATH_MAKE_ORDER_CID,
    // PATH_PRE_BOOKING,
    // PATH_BOOKING_MORE,
    PATH_ORDER_LIST,
    PATH_HPL_ORDER_LIST,
    PATH_HPL_QQ_ORDER_LIST,
    PATH_ONE_ORDER_LIST,
    PATH_USER_LIST,
    PATH_MAERSK_LIST,
    PATH_NAVIGATION_PAGES,
    PATH_QUERY_ACCOUNT_LIST,
    PATH_BOOK_ACCOUNT_LIST,
    PATH_GO_ACCOUNT_LIST,
    PATH_CHECK_ACCOUNT_LIST,
    PATH_HPL_ACCOUNT_LIST,
    // PATH_BOOKING,
    // PATH_CESHI_PAGES,
    // PATH_SHIPPING_PAGES,
    PATH_API_LIST,
    PATH_CHECK_LIST,
    PATH_QUERY_LIST,
    PATH_CMA_QUERY_LIST,
    PATH_MSK_API_LIST,
    PATH_BOOKING_LIST,
    PATH_GETCMANAME_LIST,
    // PATH_CMA_LIST,
    PATH_HPL_LIST,
    PATH_MSC_LIST,
    PATH_ONE_LIST,
    PATH_OOCL_LIST,
    PATH_GO_LIST,
    PATH_BOOK_TEMP_LIST,
    // PATH_ERROR_LIST,
    // PATH_CESHI_LIST,
    PATH_BASE_LIST,
    PATH_SHIPPING_LIST,
    PATH_BOOK_TASK_LIST,
    PATH_BOOK_HPL_LIST,
    PATH_BOOK_TASK_API_LIST,
    PATH_REMIND_LIST,
    PATH_BOOK_ORDER_LIST,
    PATH_HPL_BOOK_ORDER_LIST,
    PATH_HPL_QQ_BOOK_ORDER_LIST,
    PATH_HPL_QQ_AUTO_BOOK_ORDER_LIST,
    PATH_ONE_BOOK_ORDER_LIST,
} from '@/router/path';
function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}
const LAYOUT_MENU = [
    // {
    //     key: getPath([PATH_MAKE_ORDER_LIST]),
    //     label: '订舱',
    //     icon: <Sailboat />,
    // },
    {
        key: getPath([PATH_BOOK_ORDER_LIST]),
        label: '订舱',
        icon: <Sailboat />,
    },
    {
        key: getPath([PATH_HPL_BOOK_ORDER_LIST]),
        label: 'Hpl QQ Spot定舱',
        icon: <Sailboat />,
    },
    {
        key: getPath([PATH_HPL_QQ_BOOK_ORDER_LIST]),
        label: 'Hpl QQ 订舱',
        icon: <Sailboat />,
    },
    {
        key: getPath([PATH_HPL_QQ_AUTO_BOOK_ORDER_LIST]),
        label: 'Hpl QQ 自动订舱',
        icon: <Sailboat />,
    },
    {
        key: getPath([PATH_ONE_BOOK_ORDER_LIST]),
        label: 'ONE订舱',
        icon: <Sailboat />,
    },
    
    {
        key: getPath([PATH_ONE_ORDER_LIST]),
        label: 'ONE订单列表',
        icon: <TransactionOrder />,
    },
    // {
    //     key: getPath([PATH_MAKE_ORDER_CID]),
    //     label: '获取订舱CID',
    //     icon: <Sailboat />,
    // },
    // {
    //     key: getPath([PATH_MAKE_ORDER]),
    //     label: '订舱',
    //     icon: <Sailboat />,
    // },
    // {
    //     key: getPath([PATH_BOOKING]),
    //     label: '订舱',
    //     icon: <Sailboat />,
    // },
    // {
    //     key: getPath([PATH_PRE_BOOKING]),
    //     label: '预订舱',
    //     icon: <Order />,
    // },
    // {
    //     key: getPath([PATH_BOOKING_MORE]),
    //     label: '加载更多订舱',
    //     icon: <MoreTwo />,
    // },
    {
        key: getPath([PATH_ORDER_LIST]),
        label: '订单列表',
        icon: <TransactionOrder />,
    },
    {
        key: getPath([PATH_HPL_ORDER_LIST]),
        label: 'Hpl QQS 订单列表',
        icon: <TransactionOrder />,
    },
    {
        key: getPath([PATH_HPL_QQ_ORDER_LIST]),
        label: 'Hpl QQ 订单列表',
        icon: <TransactionOrder />,
    },
    {
        key: getPath([PATH_USER_LIST]),
        label: 'Maersk Go 用户列表',
        icon: <TransactionOrder />,
    },
    {
        key: getPath([PATH_MAERSK_LIST]),
        label: 'Maersk Go 列表',
        icon: <TransactionOrder />,
    },
    getItem('查询列表', 'sub2', <TransactionOrder />, [
        getItem('MSK列表', getPath([PATH_QUERY_LIST]), <TransactionOrder />),
        getItem('MSK Api列表', getPath([PATH_MSK_API_LIST]), <TransactionOrder />),
        getItem('CMA查询', getPath([PATH_CMA_QUERY_LIST]), <TransactionOrder />),
        getItem('HPL列表', getPath([PATH_HPL_LIST]), <TransactionOrder />),
        getItem('GO列表', getPath([PATH_GO_LIST]), <TransactionOrder />),
        getItem('API列表', getPath([PATH_API_LIST]), <TransactionOrder />),
        getItem('MSC列表', getPath([PATH_MSC_LIST]), <TransactionOrder />),
        getItem('ONE列表', getPath([PATH_ONE_LIST]), <TransactionOrder />),
        getItem('OOCL列表', getPath([PATH_OOCL_LIST]), <TransactionOrder />),
        getItem('check列表', getPath([PATH_CHECK_LIST]), <TransactionOrder />),
    ]),
    {
        key: getPath([PATH_NAVIGATION_PAGES]),
        label: '导航黄页',
        icon: <TransactionOrder />,
    },
    // {
    //     key: getPath([PATH_CESHI_PAGES]),
    //     label: '测试',
    //     icon: <TransactionOrder />,
    // },
    // {
    //     key: getPath([PATH_SHIPPING_PAGES]),
    //     label: '航运费列表',
    //     icon: <TransactionOrder />,
    // },
    {
        key: getPath([PATH_BOOKING_LIST]),
        label: '订舱列表',
        icon: <TransactionOrder />,
    },
    {
        key: getPath([PATH_GETCMANAME_LIST]),
        label: 'CMA账号列表',
        icon: <TransactionOrder />,
    },
    // {
    //     key: getPath([PATH_CMA_LIST]),
    //     label: 'CMA列表',
    //     icon: <TransactionOrder />,
    // },
    // {
    //     key: getPath([PATH_CESHI_LIST]),
    //     label: '测试',
    //     icon: <TransactionOrder />,
    // },
    {
        key: getPath([PATH_BASE_LIST]),
        label: '基础端口列表',
        icon: <TransactionOrder />,
    },
    {
        key: getPath([PATH_SHIPPING_LIST]),
        label: '航线列表',
        icon: <TransactionOrder />,
    },
    getItem('任务列表', 'sub3', <TransactionOrder />, [
        getItem('任务列表', getPath([PATH_BOOK_TASK_LIST]), <TransactionOrder />),
        getItem('Hpl任务列表', getPath([PATH_BOOK_HPL_LIST]), <TransactionOrder />),
        getItem('API任务列表', getPath([PATH_BOOK_TASK_API_LIST]), <TransactionOrder />),
    ]),
    {
        key: getPath([PATH_REMIND_LIST]),
        label: '提醒列表',
        icon: <TransactionOrder />,
    },
    // {
    //     key: getPath([PATH_ERROR_LIST]),
    //     label: '429错误列表',
    //     icon: <TransactionOrder />,
    // },

    getItem('账号列表', 'sub1', <TransactionOrder />, [
        getItem('订舱账号列表', getPath([PATH_BOOK_ACCOUNT_LIST]), <TransactionOrder />),
        getItem('go账号列表', getPath([PATH_GO_ACCOUNT_LIST]), <TransactionOrder />),
        getItem('检查账号列表', getPath([PATH_CHECK_ACCOUNT_LIST]), <TransactionOrder />),
        getItem('hpl账号列表', getPath([PATH_HPL_ACCOUNT_LIST]), <TransactionOrder />),
        getItem('小吴订舱账号列表', getPath([PATH_BOOK_TEMP_LIST]), <TransactionOrder />),
    ]),
];

export default LAYOUT_MENU;
